import { Controller } from "@hotwired/stimulus"

// Generic section-tab switcher. Tabs and panels are matched by their
// `data-section` attribute. Clicking a tab shows its panel and hides
// the rest.
export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    const params = new URLSearchParams(window.location.search)
    const tab = params.get("tab")
    if (tab) this.activate(tab)
  }

  select(event) {
    this.activate(event.currentTarget.dataset.section)
  }

  activate(section) {
    this.tabTargets.forEach(t => {
      t.classList.toggle("tab-active", t.dataset.section === section)
    })

    this.panelTargets.forEach(p => {
      p.classList.toggle("hidden", p.dataset.section !== section)
    })
  }
}
